import { render, staticRenderFns } from "./StockExits.vue?vue&type=template&id=0c0e8536&scoped=true"
import script from "./StockExits.vue?vue&type=script&lang=js"
export * from "./StockExits.vue?vue&type=script&lang=js"
import style0 from "./StockExits.vue?vue&type=style&index=0&id=0c0e8536&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e8536",
  null
  
)

export default component.exports